<template>
  <div class="list">
    <div class="center">
      <div v-for="(item, index) in list" :key="index">
        <div
          class="box"
          v-if="(type == '2' && item.applyState == 2) || type == '1'"
        >
          <div class="box-center" @click="toUrl(item)">
            <!-- <img class="img-1" src="@/assets/medal/file.png" alt="" /> -->
            <img
              class="img-1"
              v-if="item.nominType == '2'"
              src="@/assets/newMedal/tibao/1.svg"
              alt=""
            />
            <img
              class="img-1"
              v-if="item.nominType == '1'"
              src="@/assets/newMedal/tibao/2.svg"
              alt=""
            />
            <div style="flex: 1">
              <p class="title">
                {{ item.nominated }}
                <span
                  class="tabMarker"
                  :class="
                    item.applyState == 1
                      ? 'colorYellow'
                      : item.applyState == 2
                      ? 'colorGreen'
                      : item.applyState == 3
                      ? 'colorRed'
                      : ''
                  "
                  >{{
                    item.applyState == 1
                      ? "审批中"
                      : item.applyState == 2
                      ? "已审批"
                      : item.applyState == 3
                      ? "已拒绝"
                      : ""
                  }}</span
                >
              </p>
              <div class="messageOrBtn">
                <div>
                  {{ item.nominee }} <span v-if="item.nominDeptStr">|</span>
                  {{ item.nominDeptStr }}
                </div>
                <div @click.stop="down(item)">
                  <img src="@/assets/newMedal/tibao/3.svg" alt="" />
                  导出
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="right_con">
            <div
              class="huizhang"
              @click="handleAddBadge"
              v-if="showUserBadge && type == 2"
            > -->
          <!-- v-if="type == 2"-->
          <!-- <img src="@/assets/newsNotice/huizhang.png" alt="" />
              <p>徽章</p>
            </div> -->
          <!-- <div class="box-right" @click="down(item)">
              <img src="@/assets/medal/edit000.png" alt="" />
              <p>导出</p>
            </div> -->
          <!-- </div> -->
        </div>
      </div>
    </div>

    <div class="footer">
      <van-button @click="downItem">
        <img src="@/assets/medal/editFFF.png" alt="" />
        <span>导出汇总</span>
      </van-button>
    </div>
    <van-dialog
      class="dialog"
      v-model="showTip"
      :showConfirmButton="false"
      z-index="1999"
    >
      <div class="dialog_header">
        <div></div>
        <div class="dialog_title">徽章赠送</div>
        <div>
          <van-icon name="cross" @click="handelNo" />
        </div>
      </div>
      <van-form label-width="70" label-align="right">
        <van-field
          v-model="form.cardName"
          name="卡片类型"
          label="卡片类型："
          placeholder="卡片类型"
          readonly
        />

        <van-field name="关键词" label="关键词：" placeholder="请选择关键词">
          <template #input>
            <el-select
              v-model="form.medalId"
              placeholder="请选择关键词"
              ref="select3"
              @blur.native.capture="onblur3"
              @hook:mounted="cancalReadOnly3"
              @visible-change="cancalReadOnly3"
              @change="changeMedalId"
            >
              <el-option
                v-for="item in optionsKeyword"
                :key="item.id"
                :label="item.medalName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
        </van-field>
        <van-field
          v-model="form.point"
          name="分值"
          label="分值："
          placeholder="分值"
          readonly
        />
        <van-field name="赠送人" label="赠送人：" placeholder="请输入赠送人">
          <template #input>
            <el-select
              v-model="form.reciverEmpno"
              placeholder="请输入赠送名字"
              clearable
              filterable
              remote
              :remote-method="changeOption"
              :loading="loadingSelect"
              ref="select"
              @blur.native.capture="onblur"
              @hook:mounted="cancalReadOnly"
              @visible-change="cancalReadOnly"
            >
              <el-option
                v-for="item in options"
                :key="item.workcode"
                :label="item.orgname + '-' + item.name"
                :value="item.workcode"
              >
              </el-option>
            </el-select>
          </template>
        </van-field>
        <van-field name="抄送人" label="抄送人：" placeholder="抄送人">
          <template #input>
            <el-select
              v-model="form.ccEmpno"
              placeholder="请选择抄送人"
              multiple
              filterable
              remote
              :remote-method="changeOption"
              :loading="loadingSelect"
              ref="select2"
              @blur.native.capture="onblur2"
              @hook:mounted="cancalReadOnly2"
              @visible-change="cancalReadOnly2"
            >
              <el-option
                v-for="item in options"
                :key="item.workcode"
                :label="item.orgname + '-' + item.name"
                :value="item.workcode"
              >
              </el-option>
            </el-select>
          </template>
        </van-field>
        <div class="dialog-reason">
          <div>
            <van-field
              v-model="form.reason"
              rows="2"
              autosize
              label="赠送理由："
              type="textarea"
              maxlength="200"
              placeholder="请输入赠送理由"
              show-word-limit
            />
          </div>
        </div>
      </van-form>

      <div class="dialog-btn">
        <el-button @click="handelNo">取消</el-button>
        <el-button
          @click="handelOk"
          style="background: rgba(72, 158, 108, 1); color: #fff"
          :disabled="isDisabled"
          >确认</el-button
        >
      </div>
    </van-dialog>
  </div>
</template>

<script>
import api from "@/apis/medal";
import { downloadExcel } from "@/utils/tools";
export default {
  name: "list",
  props: {
    type: {
      type: String,
      default: "1",
    },
    searchValue: {
      type: String,
      default: "",
    },
    newText: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      list: [],
      showTip: false,
      form: {
        cardName: "",
        cardId: "",
        point: "",
        senderEmpno: "",
        reciverEmpno: "",
        ccEmpno: [],
        medalId: "",
      },
      isDisabled: false,
      loadingSelect: false,
      options: [],
      optionsKeyword: [],
      showUserBadge: false,
    };
  },
  watch: {
    //监听搜索框的值变化
    searchValue(val) {
      console.log(val, "valval");

      this.getList();
    },
  },
  created() {},
  mounted() {
    this.showUserBadge = this.$store.state.userInfo.username == "10004381";
    console.log("type,", this.type);
    this.getList();
  },
  methods: {
    //导出汇总
    downItem() {
      this.$message({
        type: "success",
        message: "导出中，请稍等",
        duration: 2000,
      });
      api.downGatherExcel({ type: this.type }).then((data) => {
        downloadExcel(data, "荣誉勋章评选汇总表", "xlsx");
        this.$message({
          type: "success",
          message: "导出完成",
          duration: 2000,
        });
      });
    },
    //获取列表
    getList() {
      api
        .queryMedalTaskDetail({ type: this.type, keyWord: this.searchValue })
        .then((data) => {
          this.list = data.data;
          if (this.type == 2 && this.newText) {
            this.list = this.list.filter((item) => item.title == this.newText);
          }
        });
    },
    //导出
    down(item) {
      this.$message({
        type: "success",
        message: "导出中，请稍等",
        duration: 2000,
      });
      api.downPdf({ id: item.id }).then((data) => {
        downloadExcel(
          data,
          `${item.nominDeptStr + item.nominee + item.title}`,
          "zip"
        );
        this.$message({
          type: "success",
          message: "导出完成",
          duration: 2000,
        });
      });
    },
    //跳转提报详情
    toUrl(item) {
      this.$router.push({
        path: "/mobile/medal/outsideDetail",
        query: {
          id: item.id,
        },
      });
    },
    //赠送徽章
    handleAddBadge() {
      this.queryDataMedalType();
      this.showTip = true;
    },
    //取消赠送
    handelNo() {
      this.showTip = false;
      this.form = {};
    },
    //确认赠送
    handelOk() {
      if (!this.form.medalId) {
        return this.$message({
          message: "请选择关键词",
          type: "warning",
        });
      }
      if (!this.form.reciverEmpno) {
        return this.$message({
          message: "请选择赠与人",
          type: "warning",
        });
      }
      if (!this.form.reason) {
        return this.$message({
          message: "请输入赠送理由",
          type: "warning",
        });
      }
      this.isDisabled = true;
      const json = {
        medalId: this.form.medalId,
        receiverEmpno: this.form.reciverEmpno,
        ccEmpno: this.form.ccEmpno.join(","),
        reason: this.form.reason,
        senderEmpno: this.$store.state.userInfo.username,
        sourceType: 3,
      };
      api
        .medalCardSendApi(json)
        .then((res) => {
          if (res.code == 200) {
            this.showTip = false;
            this.form = {};
            this.$message({
              message: "赠送成功",
              type: "success",
            });
          }
          this.isDisabled = false;
        })
        .catch(() => {
          this.isDisabled = false;
        });
    },

    // 查询 列表
    queryDataMedalType() {
      api.queryDataMedalType({ flagType: "3" }).then((res) => {
        if (res.code == 200) {
          this.optionsKeyword = res.data[0].medals.map((item) => {
            item.id = Number(item.id);
            return item;
          });
          // this.form.cardName = res.data[0].medalTypeName;
          // this.form.cardId = res.data[0].id;
          this.$set(this.form, "cardName", res.data[0].medalTypeName);
          this.$set(this.form, "cardId", res.data[0].id);
        }
      });
    },
    // 查询 抄送人
    changeOption(value) {
      this.loadingSelect = true;
      api
        .quaGetEmployeeInfo({
          name: value,
        })
        .then((data) => {
          this.options = data.data;
          this.loadingSelect = false;
        });
    },
    // 在苹果手机上唤起键盘
    onblur() {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          //判断iPhone|iPad|iPod|iOS
          this.$refs.select.blur();
        }
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    // 在苹果手机上唤起键盘 取消只读
    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
        }
      });
    },
    onblur2() {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          //判断iPhone|iPad|iPod|iOS
          this.$refs.select2.blur();
        }
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    // 在苹果手机上唤起键盘 取消只读
    cancalReadOnly2(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { select2 } = this.$refs;
          console.log("this.$refs", this.$refs, select2);
          const input = select2?.$el.querySelector(".el-input__inner");
          input?.removeAttribute("readonly");
        }
      });
    },
    // 在苹果手机上唤起键盘
    onblur3() {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          //判断iPhone|iPad|iPod|iOS
          this.$refs.select3.blur();
        }
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    // 在苹果手机上唤起键盘 取消只读
    cancalReadOnly3(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { select3 } = this.$refs;
          const input = select3?.$el.querySelector(".el-input__inner");
          input?.removeAttribute("readonly");
        }
      });
    },
    // 选择关键词
    changeMedalId(value) {
      if (value) {
        this.$nextTick(() => {
          this.form.point = this.optionsKeyword.filter(
            (item) => item.id == value
          )[0].point;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
.list {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.center {
  overflow: auto;
  // flex: 1;
  height: calc(100vh - 420px);
  // 去除滚动条
  &::-webkit-scrollbar {
    display: none;
  }
}
.box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 28px;
  margin-bottom: 30px;
  background: #fff;
  border-radius: 40px;
  padding: 30px;
  .box-center {
    display: flex;
    align-items: flex-start;
    width: 100%;
    .img-1 {
      margin-right: 30px;
      width: 40px;
      height: 50px;
    }
    div {
      color: rgba(150, 155, 158, 1);
      // width: 540px;
      // flex: 1;
      p:nth-child(1) {
        color: black;
        font-size: 30px;
        margin-bottom: 10px;
      }
    }
    .title {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      .tabMarker {
        flex-shrink: 0;
        display: block;
        font-size: 22px;
        margin-left: 20px;
        padding: 5px 10px;
        border-radius: 10px;
        margin-right: 10px;
      }
      .colorYellow {
        background-color: #fff3e8;
        color: #ff8e20;
      }

      .colorRed {
        background-color: #f6eef0;
        color: red;
      }

      .colorGreen {
        background-color: #edf5f2;
        color: #4ea27c;
      }
    }

    .messageOrBtn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 30px;
      div:nth-child(2) {
        display: flex;
        align-items: center;
        background: #f2f2f2;
        color: #7d8592;
        padding: 15px;
        border-radius: 10px;
        white-space: nowrap;
      }
    }
  }
  .right_con {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    .huizhang {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-right: 10px;

      img {
        width: 30px;
        height: 40px;
      }
      p {
        font-weight: 400;
        font-size: 22px;
        color: #969b9e;
        flex-shrink: 0;
      }
    }
  }
  .box-right {
    color: rgba(150, 155, 158, 1);
    text-align: center;
    flex-shrink: 0;
    img {
      width: 36px;
      height: 34px;
      margin-top: 5px;
    }
    p {
      font-weight: 400;
      font-size: 22px;
      color: #969b9e;
    }
  }
}
.footer {
  ::v-deep {
    .van-button {
      background: rgba(78, 162, 124, 1);
      border-radius: 10px;
      width: 90%;
      margin-left: 5%;
      height: 90px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;
      margin-bottom: 20px;
      .van-button__text {
        display: flex;
        align-items: center;
      }
      img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
        margin-top: -4px;
      }
      span {
        display: inline-block;
        color: #fff;
        // margin-bottom: 10px;
        font-size: 30px;
      }
    }
  }
}
.dialog {
  // height: 218px * $zoom;
  padding: 30px;
  .dialog_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    font-weight: bold;
    font-size: 32px;
    color: #282b32;
  }

  .dialog-people {
    margin-bottom: 30px;
  }
  ::v-deep {
    .van-cell::after {
      border: 0;
    }
    .el-input__inner {
      border: 0;
      background: #f7f9fa;
      border-radius: 10px;
    }
  }
  .dialog-reason {
    ::v-deep {
      .van-cell {
        // background: rgba(244, 244, 244, 1);
        display: flex;
        flex-direction: column;
      }

      .van-field__control {
        // height: 200px !important;
      }
      .van-field__value {
        background: rgba(244, 244, 244, 1);
        padding: 20px 20px;
        border-radius: 10px;
        margin-top: 20px;
      }
    }
  }

  ::v-deep {
    .el-input__inner {
      min-height: 22px * $zoom !important;
    }
  }

  .cc {
    ::v-deep {
      .el-select__tags {
        max-width: none !important;
      }

      .el-input__suffix {
        display: none;
      }
    }
  }

  .dialog-btn {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 30px;
    width: 100%;

    button {
      width: 200px;
      height: 80px;
      border-radius: 40px;
      font-size: 28px;
    }
  }
}
</style>
